const getItemsSize = (items) => {
  const itemsHeight = items.filter(({ height }) => height).map(({ height }) => height);
  const itemsWidth = items.filter(({ width }) => width).map(({ width }) => width);

  return { itemsHeight, itemsWidth };
};

export default getItemsSize;
